module.exports = __webpack_public_path__ + "img/technical-support.b4629179.svg";